const Heading = (props) => {
  return (
    <div>
      <h2 className="heading--2">{props.children}</h2>
    </div>
  );
};

export default Heading;
